var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lee-platform-container"},[_c('el-tabs',{attrs:{"type":"card"},model:{value:(_vm.active),callback:function ($$v) {_vm.active=$$v},expression:"active"}},[_c('el-tab-pane',{attrs:{"label":"抖音号","name":"douyin"}},[_c('lee-tiktok')],1),_c('el-tab-pane',{attrs:{"label":"快手号","name":"kuaishou"}},[_c('lee-kuaishou')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }